import { useViewport } from "@xyflow/react";
import type { HGuide, VGuide } from "../../lib/canvas-snap";

interface Props {
  vGuide: VGuide | null;
  hGuide: HGuide | null;
}

const PAD = 200;

export default function AlignGuides({ vGuide, hGuide }: Props) {
  const { x, y, zoom } = useViewport();
  if (!vGuide && !hGuide) return null;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: 4,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          transform: `translate(${x}px, ${y}px) scale(${zoom})`,
          transformOrigin: "0 0",
        }}
      >
        {vGuide && (
          <div
            style={{
              position: "absolute",
              left: vGuide.x - 0.5,
              top: vGuide.yMin - PAD,
              width: 1,
              height: vGuide.yMax - vGuide.yMin + PAD * 2,
              background: "#d62a4a",
            }}
          />
        )}
        {hGuide && (
          <div
            style={{
              position: "absolute",
              top: hGuide.y - 0.5,
              left: hGuide.xMin - PAD,
              height: 1,
              width: hGuide.xMax - hGuide.xMin + PAD * 2,
              background: "#d62a4a",
            }}
          />
        )}
      </div>
    </div>
  );
}
